import axios from "axios";
const { REACT_APP_AGENT_ENFANTS_API_URL, REACT_APP_FICHE_AGENT_V3_API_URL, REACT_APP_GET_PARAM_ENFANTS_AGE_INTERVAL_URL } = process.env;

export class AgentService {
    getAgentEnfants(numCgos, dlgId, casCode, exercice) {
        return axios.get(REACT_APP_AGENT_ENFANTS_API_URL + "?numCgos=" + numCgos + "&dlgId=" + dlgId + "&casCode="+ casCode + "&exercice=" + exercice);
    }

    getFicheAgent(numCgos, exercice) {
        return axios.get(REACT_APP_FICHE_AGENT_V3_API_URL + "?numCgos=" + numCgos + "&exercice=" + exercice);
    }

    getEnfantsParamIntervalle(dlgId, casCode, exercice) {
            return axios.get(REACT_APP_GET_PARAM_ENFANTS_AGE_INTERVAL_URL + "?dlgId=" + dlgId + "&casCode="+ casCode + "&exercice=" + exercice);
    }
}
